module.exports = __webpack_public_path__ + "63f3a1ec01c99a779ef746e76c41b808.svg";